import { action } from 'satcheljs';
export default action('ON_SET_END_TIME', function (dateTime) {
    return {
        dateTime: dateTime,
    };
});
//# sourceMappingURL=setEndTime.js.map